export default {
  // الترجمات الموجودة
  title: "Projects",
  createProject: "Create Project",
  editProject: "Edit Project",
  deleteProject: "Delete Project",
  projectDetails: "Project Details",
  projectName: "Project Name",
  projectDescription: "Project Description",
  projectStatus: "Project Status",
  startDate: "Start Date",
  endDate: "End Date",
  progress: "Progress",
  teamMembers: "Team Members",
  tasks: "Tasks",
  createdAt: "Created At",
  updatedAt: "Updated At",
  status: {
    planning: "Planning",
    inProgress: "In Progress",
    onHold: "On Hold",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  actions: {
    view: "View Project",
    edit: "Edit Project",
    delete: "Delete Project",
    manage: "Manage Project",
    addTask: "Add Task",
    addMember: "Add Member",
  },
  logs: {
    title: "Project Logs",
    activity: "Activity",
    changes: "Changes",
    noLogs: "No logs available",
  },

  // من Project.vue
  addMember: "Add Member",
  email: "Email",
  emailExistsError:
    "This email is already registered. Please use another email.",
  generalError: "An error occurred while submitting. Please try again later.",
  invalidCompanyIdOrUserId: "Invalid Company ID or User ID.",
  projectDeleted: "Project deleted successfully.",
  projectAdded: "Project added successfully.",
  deleteConfirmationTitle: "Delete Project",
  deleteConfirmationText: "Are you sure you want to delete this Project?",
  delete: "Delete",
  addProject: "Add Project",
  description: "Description",
  close: "Close",
  create: "create",
  projectsTable: "Projects ",
  projectNameRequired: "Please enter the project name.",
  projectAddedError:
    "An error occurre while adding the project. Please try again later.",
  from: "From",
  to: "To",
  projectManager: "Project Manager",
  assignManager: "Assign Manager",
  enterDescription: "Enter Description",
  enterProjectName: "Enter Project Name",
  saving: "Saving...",
  noProjects: "No projects found.",
  createee: "Create your project",
  departments: "Departments",
  selectDepartment: "Select Department",
  inactive: "Inactive",
  active: "Active",
  errorOccurred: "An error occurred",
  advancedSettings: "Advanced Settings",
  searchEmployees: "Search employees...",
  errorFetchingProjects: "Error fetching projects",

  // من ProjectsTable.vue
  // status: "Status",
  projectCreatedBy: "created by",
  departmentName: "Department",
  edit: "Edit",
  deleteConfirmationSuccess: "Project deleted successfully.",
  update: "Update",
  projectUpdatedSuccessfully: "Project updated successfully",
  projectDeletedSuccessfully: "Project deleted successfully",
  deadline: "Deadline",
  log: "Log",
  info: "Info",
  statusUpdatedSuccessfully: "Status updated successfully",
  noLogsAvailable: "No logs available",
  changedTheField: "changed the field",
  onDate: "On",
  noManager: "No Manager",
  noDepartment: "No Department",
  openTaskDescription: "Open Task Description",
  searchManager: "Search manager...",
  errorUpdatingStatus: "Error updating status",
  errorUpdatingProject: "Error updating project",
  errorDeletingProject: "Error deleting project",
  loading: "Loading...",
};
